module.exports = __webpack_public_path__ + "static/img/p3.c9f25dd4.png";